import { FC, useRef } from 'react';
import { AriaButtonProps, useButton } from 'react-aria';
import { Button } from '../Button';

type CalendarButtonProps = AriaButtonProps<'button'>;

export const CalendarButton: FC<CalendarButtonProps> = (props) => {
    const ref = useRef(null);
    const { buttonProps } = useButton(props, ref);
    return (
        <Button
            {...buttonProps}
            onClickEvent="Calendar Button Clicked"
            ref={ref}
            size="sm"
            variant="unstyled"
        >
            {props.children}
        </Button>
    );
};
